import { useParams } from 'react-router-dom'

// サンプルユーザーデータ
const userData = {
  'user-003': {
    id: 'user-003',
    displayName: 'Baseクリニック赤坂',
    organizationType: '医療機関',
    name: '吉岡 紘平',
    reading: 'よしおか こうへい',
    organizations: ['医療機関', '移植医療機関(正会員)', 'メンション不可(医療機関集会)'],
    preferredOrganization: '医療機関',
    birthday: '',
    joinDate: '',
    employeeId: '',
    timezone: '(UTC+09:00) 大阪、札幌、東京',
    language: 'Webブラウザーの設定に従う',
    email: 'basec.clinic@gmail.com',
    mobile: '',
    phone: '',
    extension: '',
    displayNameOther: '日本語',
    url: '',
    services: 'kintone',
    avatarUrl: '/avatars/yoshioka.jpg',
  },
  'user-004': {
    id: 'user-004',
    displayName: '医療法人社団桜伸会　サンテクリニック',
    organizationType: '移植医療機関(正会員)',
    name: '桜伸会 サンテクリニック',
    reading: 'おうしんかい さんてくりにっく',
    organizations: ['医療機関', '移植医療機関(正会員)', 'メンション不可(医療機関集会)'],
    preferredOrganization: '移植医療機関(正会員)',
    birthday: '',
    joinDate: '',
    employeeId: '',
    timezone: '(UTC+09:00) 大阪、札幌、東京',
    language: 'Webブラウザーの設定に従う',
    email: 'info@sante-clinic.jp',
    mobile: '',
    phone: '03-5565-9800',
    extension: '',
    displayNameOther: '日本語',
    url: 'http://sante-clinic.jp',
    services: 'kintone',
    avatarUrl: '/avatars/sante.jpg',
  },
}

export default function UserProfile() {
  const { id } = useParams()
  const user = userData[id as keyof typeof userData] || userData['user-003']

  return (
    <>
      <header className="aip-main__header">
        <div className="aip-main__header-container">
          <h1 className="aip-main__header-title">ユーザープロフィール</h1>
        </div>
      </header>

      <div className="aip-main__content">
        <div className="profile-container">
          {/* プロフィールヘッダー */}
          <div className="profile-header">
            <div className="profile-avatar">
              {user.avatarUrl ? (
                <img src={user.avatarUrl} alt={user.displayName} />
              ) : (
                <span>{user.displayName.charAt(0)}</span>
              )}
            </div>
            <div className="profile-info">
              <h2 className="profile-name">{user.displayName}</h2>
              <span className="profile-type">{user.organizationType}</span>
            </div>
          </div>

          {/* 基本情報 */}
          <section className="profile-section">
            <h3 className="profile-section__title">
              <span className="material-symbols-outlined">person</span>
              基本情報
            </h3>
            <div className="profile-grid">
              <div className="profile-field">
                <label className="profile-field__label">表示名</label>
                <span className="profile-field__value">{user.displayName}</span>
              </div>
              <div className="profile-field">
                <label className="profile-field__label">名前</label>
                <span className="profile-field__value">{user.name}</span>
              </div>
              <div className="profile-field">
                <label className="profile-field__label">よみがな</label>
                <span className="profile-field__value">{user.reading || '-'}</span>
              </div>
              <div className="profile-field profile-field--full">
                <label className="profile-field__label">組織</label>
                <div className="profile-field__value">
                  {user.organizations.map((org, index) => (
                    <span key={index} className="profile-tag">{org}</span>
                  ))}
                </div>
              </div>
              <div className="profile-field">
                <label className="profile-field__label">優先する組織</label>
                <span className="profile-field__value">{user.preferredOrganization}</span>
              </div>
              <div className="profile-field">
                <label className="profile-field__label">誕生日</label>
                <span className="profile-field__value">{user.birthday || '-'}</span>
              </div>
              <div className="profile-field">
                <label className="profile-field__label">入社日</label>
                <span className="profile-field__value">{user.joinDate || '-'}</span>
              </div>
              <div className="profile-field">
                <label className="profile-field__label">従業員ID</label>
                <span className="profile-field__value">{user.employeeId || '-'}</span>
              </div>
              <div className="profile-field">
                <label className="profile-field__label">タイムゾーン</label>
                <span className="profile-field__value">{user.timezone}</span>
              </div>
              <div className="profile-field">
                <label className="profile-field__label">言語</label>
                <span className="profile-field__value">{user.language}</span>
              </div>
            </div>
          </section>

          {/* 連絡先情報 */}
          <section className="profile-section">
            <h3 className="profile-section__title">
              <span className="material-symbols-outlined">call</span>
              連絡先情報
            </h3>
            <div className="profile-grid">
              <div className="profile-field">
                <label className="profile-field__label">メールアドレス</label>
                <a href={`mailto:${user.email}`} className="profile-field__link">{user.email}</a>
              </div>
              <div className="profile-field">
                <label className="profile-field__label">携帯電話</label>
                <span className="profile-field__value">{user.mobile || '-'}</span>
              </div>
              <div className="profile-field">
                <label className="profile-field__label">電話番号</label>
                {user.phone ? (
                  <a href={`tel:${user.phone}`} className="profile-field__link">{user.phone}</a>
                ) : (
                  <span className="profile-field__value">-</span>
                )}
              </div>
              <div className="profile-field">
                <label className="profile-field__label">内線</label>
                <span className="profile-field__value">{user.extension || '-'}</span>
              </div>
            </div>
          </section>

          {/* その他 */}
          <section className="profile-section">
            <h3 className="profile-section__title">
              <span className="material-symbols-outlined">more_horiz</span>
              その他
            </h3>
            <div className="profile-grid">
              <div className="profile-field">
                <label className="profile-field__label">別言語での表示名</label>
                <span className="profile-field__value">{user.displayNameOther}</span>
              </div>
              <div className="profile-field">
                <label className="profile-field__label">URL</label>
                {user.url ? (
                  <a href={user.url} target="_blank" rel="noopener noreferrer" className="profile-field__link">
                    {user.url}
                  </a>
                ) : (
                  <span className="profile-field__value">-</span>
                )}
              </div>
              <div className="profile-field">
                <label className="profile-field__label">利用中のサービス</label>
                <span className="profile-field__value">{user.services}</span>
              </div>
            </div>
          </section>
        </div>
      </div>

      <style>{`
        .profile-container {
          max-width: 800px;
          margin: 0 auto;
        }

        .profile-header {
          display: flex;
          align-items: center;
          gap: var(--spacing-lg);
          padding: var(--spacing-xl);
          background-color: var(--background-primary);
          border-radius: var(--border-radius-lg);
          box-shadow: var(--shadow-sm);
          margin-bottom: var(--spacing-lg);
        }

        .profile-avatar {
          width: 120px;
          height: 120px;
          border-radius: var(--border-radius-lg);
          background-color: var(--color-blue500);
          color: white;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 3rem;
          font-weight: 600;
          overflow: hidden;
        }

        .profile-avatar img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .profile-info {
          flex: 1;
        }

        .profile-name {
          font-size: 1.5rem;
          font-weight: 600;
          margin-bottom: var(--spacing-xs);
        }

        .profile-type {
          display: inline-block;
          padding: 4px 12px;
          background-color: var(--color-solid-gray100);
          color: var(--text-secondary);
          border-radius: var(--border-radius-sm);
          font-size: 0.75rem;
        }

        .profile-section {
          background-color: var(--background-primary);
          padding: var(--spacing-lg);
          border-radius: var(--border-radius-lg);
          box-shadow: var(--shadow-sm);
          margin-bottom: var(--spacing-lg);
        }

        .profile-section__title {
          display: flex;
          align-items: center;
          gap: var(--spacing-sm);
          font-size: 1rem;
          font-weight: 600;
          margin-bottom: var(--spacing-md);
          padding-bottom: var(--spacing-sm);
          border-bottom: 1px solid var(--border-color);
        }

        .profile-section__title .material-symbols-outlined {
          color: var(--color-blue600);
        }

        .profile-grid {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: var(--spacing-md);
        }

        .profile-field {
          display: flex;
          flex-direction: column;
          gap: var(--spacing-xs);
        }

        .profile-field--full {
          grid-column: 1 / -1;
        }

        .profile-field__label {
          font-size: 0.75rem;
          color: var(--text-secondary);
        }

        .profile-field__value {
          font-size: 0.875rem;
          color: var(--text-primary);
        }

        .profile-field__link {
          font-size: 0.875rem;
          color: var(--color-blue600);
        }

        .profile-field__link:hover {
          text-decoration: underline;
        }

        .profile-tag {
          display: inline-block;
          padding: 2px 8px;
          background-color: var(--color-blue50);
          color: var(--color-blue700);
          border-radius: var(--border-radius-sm);
          font-size: 0.75rem;
          margin-right: var(--spacing-xs);
          margin-bottom: var(--spacing-xs);
        }

        @media (max-width: 768px) {
          .profile-header {
            flex-direction: column;
            text-align: center;
          }

          .profile-grid {
            grid-template-columns: 1fr;
          }

          .profile-avatar {
            width: 100px;
            height: 100px;
            font-size: 2.5rem;
          }
        }
      `}</style>
    </>
  )
}
